module.exports = __webpack_public_path__ + "img/save-03.ca8ab4a2.svg";